import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  height: "100%",
  minHeight: 0,
  gap: 24,
  [theme.breakpoints.down("lg")]: {
    gap: 8,
  },
}));

interface IStyledImageProps extends BoxProps {
  component?: React.ElementType;
  src?: string;
}

export const StyledImage = styled(Box)<IStyledImageProps>({
  maxHeight: "100%",
  minWidth: 40,
  minHeight: 40,
  objectFit: "contain",
});
